/**
 * Drawing Toolbar Manager
 * Handles UI interactions for the drawing toolbar
 */

import { state } from '../state.js';
import { setDrawingMode, getDrawingMode, clearAllDrawings } from '../chart/drawing.js';
import { showToast } from '../ui/ui-manager.js';

let toolbarElement;
let tools = [];

export function initToolbar() {
    toolbarElement = document.getElementById('drawing-toolbar');
    if (!toolbarElement) return;

    // Cache tool buttons
    tools = Array.from(toolbarElement.querySelectorAll('.tool-btn'));

    // Add click listeners
    tools.forEach(btn => {
        btn.addEventListener('click', (e) => {
            const tool = btn.dataset.tool;
            handleToolSelect(tool, btn);
        });
    });

    // Initialize with default state
    updateActiveTool(getDrawingMode());
}

function handleToolSelect(tool, btnElement) {
    if (tool === 'clear') {
        if (confirm('すべての描画を削除しますか？')) {
            clearAllDrawings();
            showToast('描画をクリアしました', 'info');
        }
        return;
    }

    // Toggle logic for simple modes vs sticky modes can go here
    // For now, simple selection
    setDrawingMode(tool);
    state.isDrawingMode = (tool !== 'cursor'); // 'cursor' means no drawing

    updateActiveTool(tool);

    let message = '';
    switch (tool) {
        case 'line': message = '水平線モード: チャートをクリックして配置'; break;
        case 'fib': message = 'フィボナッチモード: 自動描画されます'; break; // Currently auto-fib
        case 'cursor': message = 'カーソルモード'; break;
    }

    if (tool !== 'cursor' && tool !== 'clear') {
        showToast(message, 'info');
    }

    // Dispatch event if other components need to know
    document.dispatchEvent(new CustomEvent('drawing-mode-change', { detail: { mode: tool } }));
}

function updateActiveTool(activeTool) {
    tools.forEach(btn => {
        if (btn.dataset.tool === activeTool) {
            btn.classList.add('active');
        } else {
            btn.classList.remove('active');
        }
    });
}
